import { Button, Row } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import useFriendship from '../../../../pages/user/friendship/hooks/useFriendship';
import { FriendshipDetails, FriendshipStatus } from '../../../../types/user/friendship';

interface AcceptFriendButtonProps {
    canSend: boolean;
    setCanSend: React.Dispatch<React.SetStateAction<boolean>>;
    friendshipRelation: FriendshipDetails;
    paramUsername: string;
}

export const AcceptFriendButton = ({ canSend, setCanSend, friendshipRelation, paramUsername }: AcceptFriendButtonProps) => {
    const { t } = useTranslation();

    const { friendshipStatusChanged, error, loadCheckFriendship, userAcceptFriendship } = useFriendship();

    useEffect(() => {
        if (friendshipRelation === null) {
            loadCheckFriendship(paramUsername);
        }
    }, [friendshipRelation]);

    useEffect(() => {
        if(friendshipStatusChanged !== null) {
            loadCheckFriendship(paramUsername);
        }
    }, friendshipStatusChanged)

    useEffect(() => {
        if (friendshipStatusChanged != null && friendshipStatusChanged === FriendshipStatus.ACCEPTED) {
            toast.success(t('friendship.friend_accepted', { username: paramUsername }), {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: 'colored',
                icon: '✔',
            });
        }
    }, [friendshipStatusChanged]);

    useEffect(() => {
        if (error) {
            toast.error(error, {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: 'colored',
                icon: '❌',
            });
        }
    }, [error]);

    return (
        <>
            <Button
                    variant={'primary'}
                    disabled={canSend? false : true}
                    onClick={() => {
                        setCanSend(false);
                        userAcceptFriendship(friendshipRelation.id);
                        setTimeout(() => {
                            setCanSend(true)
                        }, 2000)
                    }}
                    className={'rounded-pill me-2'}>
                    {t('friendship.text_accept')}
            </Button>
        </>
    );
};
